import Country from './Country';
import {Model} from '@vuex-orm/core';

export default class Language extends Model {
  static entity = 'languages';
  static defaults = 'languages';

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      code: this.string(''),
      defaultCountryId: this.attr(null),
      country: this.belongsTo(Country, 'code'),
    };
  }

  static methodConf = {
    http: {
      url: '/users/settings/languages',
    },
  };
}
